/* eslint-disable react-hooks/exhaustive-deps */
import {
    IonContent,
    IonPage,
    useIonViewDidEnter,
    IonLoading,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
} from '@ionic/react'
import React, { useState, useRef, useEffect } from 'react'
import Header from '../../components/Header'
import './index.css'
import QuestionList from './components/QuestionList'
import { useSelector } from 'react-redux'
import { ReduxStore } from '../../redux/reducers'
import { UserModel } from '../../model/user.model'
import {
    listIdentityQuestions,
    IdentityQuestionItem,
    PaginationModel,
} from '../../service/api/knowledge'
import { useHistory } from 'react-router'
import EmptyMsg from '../../components/EmptyMsg'
import { QuestionDetailPage } from '../../conf/routePath'
import { setLocalItem } from '../../utils'
const Learning: React.FC = () => {
    const history = useHistory()
    const userInfo = useSelector<ReduxStore, UserModel>(
        (store) => store.userInfo as UserModel
    )
    const [questions, setQuestions] = useState<IdentityQuestionItem[]>([])
    const [loadingOptions, setLoadingOptions] = useState<{
        isOpen: boolean
        message: string
    }>({
        isOpen: false,
        message: '加载中...',
    })
    /** 加载更多组件 */
    const ionInfiniteScroll = useRef<any>(null)
    /** 分页 */
    const [pagination, setPagination] = useState<PaginationModel>({
        page: 1,
        page_size: 20,
    })
    /** 没有更多知识点 */
    const [noMore, setNoMore] = useState(false)
    const [questionEmpty, setQuestionEmpty] = useState(false)
    useIonViewDidEnter(() => {
        setPagination({
            ...pagination,
            page: 1,
        })
    })
    /** 分页改变事件 */
    useEffect(() => {
        queryListIdentityQuestions()
    }, [pagination])
    /** 加载问题列表 */
    const queryListIdentityQuestions = async () => {
        if (pagination.page === 1) {
            setLoadingOptions({
                ...loadingOptions,
                isOpen: true,
            })
            setNoMore(false)
        }
        try {
            let res = await listIdentityQuestions({
                appHash: userInfo.app_hash,
                pagination: {
                    page: pagination.page,
                    page_size: 20,
                },
            })
            const reQuestions = res.data.listIdentityQuestions.rows
            setQuestionEmpty(pagination.page === 1 && reQuestions.length === 0)

            if (reQuestions.length < pagination.page_size) {
                console.log('no more')
                setNoMore(true)
            }
            if (pagination.page === 1) {
                setQuestions([...reQuestions])
            } else {
                setQuestions([...questions, ...reQuestions])
            }
        } catch (error) {
            setLoadingOptions({
                ...loadingOptions,
                isOpen: true,
                message: error.message,
            })
        }
        if (ionInfiniteScroll !== null && ionInfiniteScroll.current !== null) {
            ionInfiniteScroll.current.complete()
        }
        setLoadingOptions({
            ...loadingOptions,
            isOpen: false,
        })
    }
    return (
        <IonPage className='learning-page'>
            <IonContent className='content'>
                <Header title='新问题列表' />
                <QuestionList
                    dataSource={questions}
                    onItemClick={(item) => {
                        setLocalItem('question_item', item)
                        history.push(QuestionDetailPage, item)
                    }}
                />
                {!noMore && questions.length > 0 && (
                    <IonInfiniteScroll
                        threshold='60px'
                        ref={ionInfiniteScroll}
                        onIonInfinite={(e) =>
                            setPagination({
                                ...pagination,
                                page: pagination.page + 1,
                            })
                        }
                    >
                        <IonInfiniteScrollContent
                            loadingSpinner='bubbles'
                            loadingText='加载更多'
                        ></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                )}
                <EmptyMsg show={questionEmpty}>暂无新问题</EmptyMsg>
            </IonContent>
            <IonLoading {...loadingOptions} />
        </IonPage>
    )
}

export default Learning
